import type {
    SmriqAutoMatchSelection,
    SmriqLastCompletedServiceSelection,
} from '../types/smriq.types';

export const isAutoMatch = (
    selection: SmriqLastCompletedServiceSelection | null | undefined,
): selection is SmriqAutoMatchSelection =>
    !!selection && 'mode' in selection && selection.mode === 'auto';
